import { __read, __spreadArray } from "tslib";
import { warnLogger } from './utils/logger';
import { checkSSR } from './utils/ssr';
//
//
//
/**
 * Names of ChannelIO API functions.
 */
var CHANNEL_IO_API_NAMES = Object.freeze([
    ////////////////////////////////////////////////////////////
    // IMPORTANT:
    // Sort by order of ChannelIO official api reference document,
    // to make it easier to compare with the document.
    // - ref: https://developers.channel.io/docs/web-channelio
    ////////////////////////////////////////////////////////////
    'boot',
    'shutdown',
    'showMessenger',
    'hideMessenger',
    'openChat',
    'openWorkflow',
    'track',
    'onShowMessenger',
    'onHideMessenger',
    'onBadgeChanged',
    'onChatCreated',
    'onFollowUpChanged',
    'onUrlClicked',
    'clearCallbacks',
    'updateUser',
    'addTags',
    'removeTags',
    'setPage',
    'resetPage',
    'showChannelButton',
    'hideChannelButton',
    'setAppearance',
]);
/**
 * Names of ChannelIO command API functions.
 */
export var CHANNEL_IO_COMMAND_API_NAMES = Object.freeze(CHANNEL_IO_API_NAMES.filter(function (name) { return !name.startsWith('on'); }));
/**
 * Names of ChannelIO event API functions.
 */
export var CHANNEL_IO_EVENT_API_NAMES = Object.freeze(CHANNEL_IO_API_NAMES.filter(function (name) {
    return name.startsWith('on');
}));
//
//
//
/**
 * ChannelIO SDK.
 *
 * @see https://developers.channel.io/docs/web-channelio
 */
export var ChannelIO = function (name) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (checkSSR()) {
        return;
    }
    if (typeof window.ChannelIO !== 'function') {
        warnLogger('ChannelIO instance is not initalized yet.');
        return;
    }
    window.ChannelIO.apply(window, __spreadArray([name], __read(args), false));
};
